module.exports = __webpack_public_path__ + "media/images/bg-connecting-e2f7a08970bfe211faacd5c955298499.png";